import React from 'react';
import { StarOutlined } from '@ant-design/icons';

// 定义 props 类型
interface AIFloatButtonProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>; // 可选，因为不一定每次都需要
}

const AIFloatButton: React.FC<AIFloatButtonProps>  = ({ onClick }) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 32,
        right: 10,
        width: 36,
        height: 100,
        borderRadius: 16,
        backgroundColor: 'white',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        zIndex: 1000,
        transition: 'all 0.2s ease',
      }}
      onClick={onClick}
    >
      {/* 图标 */}
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src="/images/ai-logo.png" alt="AI" style={{ width: '26px', height: '26px' }} />
      </div>
      {/* 文字 */}
      <div
        style={{
          fontSize: 12,
          fontWeight: 500,
          lineHeight: 1.4,
          color: '#333',
          textAlign: 'center',
        }}
      >
        AI<br />助<br />理
      </div>
    </div>
  );
};

export default AIFloatButton;